import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * This function is a utility to fetch the city name from a zip code using the HonoClient.
 * @param client
 * @param zipCode
 * @returns
 */
export async function getCity(zipCode: string | null): Promise<string | null> {
	try {
		if (!zipCode) return null;
		const response = await client.addresses["zip-code"][":zipCode"].$get({
			param: { zipCode },
		});
		const data = await responseHandler(response);
		return data.city;
	} catch (_) {
		return null;
	}
}
